import { FC, ReactElement } from 'react';

import { StyleProps } from '@bonusly/design-system';
import { useBuildMonarchURL } from '@bonusly/url';

import { useIsRecognize } from '../../hooks/useIsRecognize';
import { NavLink } from './NavLink';

interface Props extends StyleProps {
	children: string;
	icon: ReactElement;
	isActive?: boolean;
	to: string;
	onTrack?: VoidFunction;
	id?: string;
	onClick?: VoidFunction;
}

export const MonarchLink: FC<Props> = ({ to, ...rest }) => {
	const isRecognize = useIsRecognize();
	const monarchURL = useBuildMonarchURL();
	const path = isRecognize ? monarchURL(to) : to;

	return <NavLink to={path} {...rest} />;
};
